module.exports = __webpack_public_path__ + "img/yes1.47488c6e.png";